(() => {
  let hasSubmitted = false;

  function handleOptionInteraction(event) {
    if (hasSubmitted) return;

    const target = event.composedPath ? event.composedPath()[0] : event.target;
    if (!target || !target.closest) return;

    const option = target.closest('.option');
    if (!option) return;

    requestAnimationFrame(function () {
      const submitBtn = container.querySelector('.submit');
      if (!submitBtn || submitBtn.disabled) return;
      hasSubmitted = true;
      submitBtn.click();
      setTimeout(function () {
        closeExitPopup(container);
      }, 1000);
    });
  }

  function closeExitPopup(container) {
    const closeBtn = container.querySelector('.close, [data-close], .icon-close, .exit-poll-close, [aria-label="Close" i]');
    if (closeBtn) {
      closeBtn.click();
      return;
    }
    container.style.display = 'none';
  }

  const container = document.querySelector('.exit-poll-popup-container');
  if (!container) return;

  container.addEventListener('click', handleOptionInteraction);
  container.addEventListener('input', handleOptionInteraction);
})();